<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="name"
          :counter="30"
          :rules="nameRules"
          label="Ваше имя"
          prepend-inner-icon="mdi-account-circle"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="phone"
          :rules="phoneRules"
          label="Номер телефона"
          prepend-inner-icon="mdi-phone"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="6" md="3">
        <v-select
          v-model="select1"
          :items="items1"
          :rules="[v => !!v || 'Поле Ширина обязательно для заполнения']"
          label="Ширина"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="6" sm="6" md="3">
        <v-select
          v-model="select3"
          :items="items3"
          :rules="[v => !!v || 'Поле Диаметр обязательно для заполнения']"
          label="Диаметр"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="6" sm="6" md="3">
        <v-select
          v-model="select2"
          :items="items2"
          :rules="[
            v => !!v || 'Поле Высота профиля обязательно для заполнения'
          ]"
          label="Высота профиля"
          outlined
          dense
          required
        ></v-select>
      </v-col>

      <v-col cols="6" sm="6" md="3">
        <v-select
          v-model="select4"
          :items="items4"
          :rules="[v => !!v || 'Поле Сезонность обязательно для заполнения']"
          label="Сезонность"
          outlined
          dense
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="text"
          outlined
          :counter="555"
          :rules="textRules"
          name="input-text"
          label="Комментарии к заказу"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-checkbox
        class="px-2"
        color="success"
        v-model="checkbox"
        :rules="[v => !!v || 'Отметить обязательно!']"
        label="Согласен на обработку своих персональных данных"
        required
      />
    </v-row>
    <v-row justify="center" align="center">
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4 mb-2"
        @click="validate"
        :loading="loading"
        outlined
        text
      >
        Подобрать
      </v-btn>
      <v-btn
        class="mr-4 mb-2"
        color="error"
        @click="reset"
        :loading="loading"
        outlined
        text
      >
        Сбросить
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import jsonItems1 from "@/assets/json/tiresForm/items1.json";
import jsonItems2 from "@/assets/json/tiresForm/items2.json";
import jsonItems3 from "@/assets/json/tiresForm/items3.json";
import jsonItems4 from "@/assets/json/tiresForm/items4.json";
export default {
  name: "FormTires",
  data: () => ({
    loading: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Введите Ваше имя",
      v =>
        (v && v.length <= 30) ||
        "Пожалуйста представьтесь не больше 30 символов"
    ],
    phone: "+7",
    phoneRules: [
      v => !!v || "Номер телефона обязательно для заполнения",
      v =>
        /^\+7\d{10}$/.test(v) ||
        "Введите Ваш номер в следующем формате +79999999999"
    ],
    text: "",
    textRules: [
      v =>
        (v && v.length <= 555) ||
        "Пожалуйста сократите Ваше сообщение до 555 символов"
    ],
    select1: null,
    select2: null,
    select3: null,
    select4: null,
    items1: jsonItems1,
    items2: jsonItems2,
    items3: jsonItems3,
    items4: jsonItems4,
    checkbox: false
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          const emailMessage = {
            name: this.name,
            phone: this.phone,
            text: `Пользователь отправил запрос с сайта по выбору комплекта резины по параметрам:
            Ширина: ${this.select1}, Высота профиля: ${this.select2}, Диаметр: ${this.select3}, Сезонность: ${this.select4}.
            Комментарий к заказу: ${this.text}`
          };
          let formData = new FormData();
          formData.append("name", emailMessage.name);
          formData.append("phone", emailMessage.phone);
          formData.append("text", emailMessage.text);
          this.$axios
            .post("https://fivetu-backend.herokuapp.com/emailtires", formData)
            .then(response => {
              this.loading = false;
              this.$refs.form.reset();
              this.$store.dispatch("setMessage", {
                type: "success",
                text: response.data
              });
            })
            .catch(err => {
              this.loading = false;
              this.$store.dispatch("setMessage", {
                type: "error",
                text: `Ошибка при отправки письма. ${err.message}`
              });
            });
        } catch (e) {
          this.loading = false;
        }
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
